import React from 'react';
import { useQuery } from 'react-query';

import styled from 'styled-components';

import { getUserCommunities } from 'apis/CommunityAPI';
import LoaderRibbed from 'components/lib/LoaderRibbed';
import { usePublicationContext } from 'components/Publication/PublicationContext';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { useAppSelector } from 'store/hook';
import { processFullHomeCommunities } from 'utils/data/communities';

import Map from './Map';
import { useWidgetContext } from '../Widget/WidgetContext';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  overflow-y: auto;
  border-radius: 16px;
  height: 100%;
  background-color: white;
`;

export const MapWidgetContent = () => {
  const { communityId } = useCommunityViewContext();
  const { publication } = usePublicationContext();
  const { filters = { competitors: [] } } = useWidgetContext();
  const filterCompetitors = filters?.competitors ?? [];

  const { selectedClient, selectedCompany } = useAppSelector((state) => state.global);

  const { data, isLoading } = useQuery({
    queryKey: [selectedClient, selectedCompany, communityId],
    queryFn: () =>
      getUserCommunities({
        communities: [communityId],
        ...(publication?.hash ? { public_hash: publication.hash } : {}),
      }),
    select: (data) => {
      const { communities, competitors } = processFullHomeCommunities(data);
      return { communities, competitors };
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const filteredCompetitors =
    filterCompetitors.length == 0
      ? data?.competitors || []
      : (data?.competitors || []).filter((competitor: any) =>
          filterCompetitors.some((value) => value == competitor?.id)
        );

  return (
    <Container>
      {isLoading && <LoaderRibbed expanded active />}
      {!isLoading && <Map communities={data?.communities || []} competitors={filteredCompetitors} />}
    </Container>
  );
};

export default MapWidgetContent;
